export default "__VITE_ASSET__DKIfdsEh__"